module.exports = __webpack_public_path__ + "static/media/DG-2.c677cf13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/services/DG-2.jpg
// module id = 97
// module chunks = 0